function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../util';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import generalRouteService from '../../services/general_route.service';
const MoveModal = _ref => {
  let {
    draggedElement,
    droppedElement,
    show,
    hideAndEmptyElements,
    allData,
    setAllData,
    route,
    isFile
  } = _ref;
  const {
    t
  } = useTranslation();
  const title = t('moving folders and files');
  const moveText = el => isFile(el) ? t('file') : t('folder');
  const body = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    className: "text-center mt-2"
  }, "".concat(moveText(draggedElement), ": ").concat(draggedElement.name, " >> ").concat(moveText(droppedElement), ": ").concat(droppedElement.name)), /*#__PURE__*/React.createElement("h3", {
    className: "text-center mt-2"
  }, t('are_you_sure')));
  const updateData = useErrorHandling(useCallback(async () => {
    const isRouteFile = route === 'folder_files';
    const folderProperty = isRouteFile ? 'folder_id' : 'parent_folder_id';
    let payload = {
      [folderProperty]: droppedElement.id || null
    };
    if (droppedElement.virtual_folder && !isRouteFile) {
      payload = _objectSpread(_objectSpread({}, payload), {}, {
        folderable_type: droppedElement.model_type,
        folderable_id: droppedElement.model_id,
        [folderProperty]: null
      });
    } else if (droppedElement.virtual_folder && isRouteFile) {
      payload = _objectSpread(_objectSpread({}, payload), {}, {
        fileable_type: droppedElement.model_type,
        fileable_id: droppedElement.model_id,
        [folderProperty]: null
      });
    }
    const response = await generalRouteService.update(route, draggedElement.id, payload);
    const indexToRemove = allData.findIndex(currentData => currentData.id === response.id);
    allData.splice(indexToRemove, 1);
    setAllData([...allData]);
    hideAndEmptyElements();
  }, [body]));
  return /*#__PURE__*/React.createElement(Modal, {
    size: "lg",
    title: title + ': ',
    show: show,
    renderBody: () => body,
    onHide: hideAndEmptyElements,
    onSubmit: () => updateData(),
    submitText: t('yes'),
    closeText: t('no'),
    submitIcon: "done"
  });
};
export default MoveModal;